import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getModuleData } from '../redux/selectors/modules';
import { updateModule } from '../redux/actions/modules';
import { useGruser } from './useGruser';

export function useModuleData<T>(moduleId: number): {
  moduleData: T;
  updateModuleData: (data: any, replace?: boolean) => void;
} {
  const dispatch = useDispatch();
  const { gruser } = useGruser();
  const moduleData = useSelector((state: any) => getModuleData(state, gruser, moduleId)) as T;

  const updateModuleData = useCallback(
    (data: any, replace = false) =>
      dispatch(
        updateModule(gruser!, {
          id: moduleId,
          moduleData: replace ? data : { ...moduleData, ...data },
        })
      ),
    [dispatch, moduleId, moduleData]
  );
  return { moduleData, updateModuleData };
}

export default useModuleData;
